import { fetchJSON } from '@/utils/http'
import { API_ROUTE } from '../backend/config'
import { Space, SpacesResponse } from './types'

export class SpacesAPI {
  async fetchSpaces(organizationId: string): Promise<SpacesResponse> {
    return await fetchJSON(`${API_ROUTE}/spaces?parentOrg=${organizationId}`)
  }

  async getSpaceById(spaceId: string): Promise<Space> {
    return await fetchJSON(`${API_ROUTE}/spaces/${spaceId}`)
  }

  async createSpace(space: {
    parentOrg: string
    displayName: string
    description?: string
    departments?: string[] // Department IDs
  }): Promise<{ doc: Space }> {
    return await fetchJSON(`${API_ROUTE}/spaces`, {
      method: 'POST',
      body: JSON.stringify(space),
    })
  }

  async updateSpace(
    spaceId: string,
    space: {
      displayName?: string
      departments?: string[] // Department IDs
    },
  ): Promise<Space> {
    return await fetchJSON(`${API_ROUTE}/spaces/${spaceId}`, {
      method: 'PATCH',
      body: JSON.stringify(space),
    })
  }

  async deleteSpace(spaceId: string): Promise<void> {
    return await fetchJSON(`${API_ROUTE}/spaces/${spaceId}`, {
      method: 'DELETE',
    })
  }

  async updateSpaceDepartments(
    spaceId: string,
    departmentIds: string[],
  ): Promise<{ doc: Space }> {
    return await fetchJSON(`${API_ROUTE}/spaces/${spaceId}`, {
      method: 'PATCH',
      body: JSON.stringify({ departments: departmentIds }),
    })
  }
}
